/* eslint-disable postcss-modules/no-unused-class */
import classNames from "classnames";
import type * as React from "react";

import style from "./Skeleton.module.css";

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: "text" | "rect" | "circle";
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  animate?: "pulse" | "wave" | false;
};

const toCssSize = (value?: number | string) => {
  if (value === undefined) {
    return undefined;
  }

  return typeof value === "number" ? `${value}px` : value;
};

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = "rect",
  width,
  height,
  radius,
  animate = "pulse",
  className,
  style: styleOverride,
  ...rest
}) => {
  let resolvedWidth = width;
  let resolvedHeight = height;

  if (variant === "circle") {
    const size = width ?? height ?? 40;
    resolvedWidth = size;
    resolvedHeight = size;
  } else if (variant === "text") {
    resolvedWidth = width ?? "100%";
    resolvedHeight = height ?? "1em";
  }

  const inlineStyle = {
    width: toCssSize(resolvedWidth),
    height: toCssSize(resolvedHeight),
    ...(radius != null ? { "--skeleton-radius": toCssSize(radius) } : null),
    ...styleOverride,
  } as React.CSSProperties;

  const { "aria-hidden": ariaHidden, ...restProps } = rest;

  return (
    <div
      aria-hidden={ariaHidden ?? true}
      {...restProps}
      className={classNames(
        style.skeleton,
        style[variant],
        animate ? style[animate] : null,
        className
      )}
      style={inlineStyle}
    />
  );
};
